import React, { useRef, useState } from 'react';
import api from '../../config/axios';
import Header from '../common/Header';
import { useNavigate } from 'react-router-dom';
import './AccountSettings.css';

const AccountSettings: React.FC<{ user: any }> = ({ user }) => {
  const navigate = useNavigate();
  const fileRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState(user.username || '');
  const [avatarUrl, setAvatarUrl] = useState(user.avatarUrl || '');
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState('');
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const flash = (m: string, isErr = false) => {
    if (isErr) { setErr(m); setMsg(''); } else { setMsg(m); setErr(''); }
    setTimeout(() => { setMsg(''); setErr(''); }, 3000);
  };

  const onLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); window.location.href = '/'; };

  const pickFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return flash('Tên không được để trống', true);
    setSaving(true);
    try {
      const form = new FormData();
      form.append('username', name.trim());
      if (file) form.append('avatar', file);
      const res = await api.patch('/api/profile', form);
      const updated = res.data.data;
      // Đồng bộ localStorage để Header/toàn app hiển thị đúng sau khi lưu.
      const stored = JSON.parse(localStorage.getItem('user') || '{}');
      localStorage.setItem('user', JSON.stringify({ ...stored, username: updated.username, avatarUrl: updated.avatarUrl }));
      setAvatarUrl(updated.avatarUrl || '');
      setFile(null);
      setPreview('');
      flash('Đã cập nhật tài khoản');
    } catch (e: any) {
      flash(e.response?.data?.message || 'Lỗi cập nhật', true);
    } finally {
      setSaving(false);
    }
  };

  const deleteAccount = async () => {
    const password = window.prompt('Nhập mật khẩu để xác nhận xoá tài khoản. Hành động này sẽ khoá quyền đăng nhập của bạn.');
    if (!password) return;
    setDeleting(true);
    try {
      await api.delete('/api/profile', { data: { password } });
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    } catch (e: any) {
      flash(e.response?.data?.message || 'Lỗi xoá tài khoản', true);
      setDeleting(false);
    }
  };

  const shown = preview || avatarUrl;

  return (
    <>
      <Header user={user} onLogout={onLogout}>
        <span className="user-role">{user.role === 'admin' ? 'Quản lý' : user.role === 'employee' ? 'Nhân viên' : 'Khách hàng'}</span>
      </Header>
      <div className="account-settings-container">
        <div className="account-settings-header">
          <button className="account-settings-back" onClick={() => navigate('/')} title="Quay lại">←</button>
          <h2 className="account-settings-title">TÀI KHOẢN CỦA TÔI</h2>
        </div>

        {msg && <div className="account-settings-msg success">{msg}</div>}
        {err && <div className="account-settings-msg error">{err}</div>}

        <form className="account-settings-form" onSubmit={save}>
          <div className="account-avatar-row">
            <div className="account-avatar" onClick={() => fileRef.current?.click()} title="Đổi ảnh đại diện">
              {shown ? <img src={shown} alt="avatar" /> : <span>{(name[0] || '?').toUpperCase()}</span>}
            </div>
            <button type="button" className="account-avatar-btn" onClick={() => fileRef.current?.click()}>Chọn ảnh</button>
            <input ref={fileRef} type="file" accept="image/*" onChange={pickFile} hidden />
          </div>

          <label>Tên hiển thị</label>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Tên của bạn" />

          <label>Email</label>
          <input value={user.email || ''} disabled />

          <button type="submit" className="account-settings-save" disabled={saving}>
            {saving ? 'Đang lưu...' : 'Lưu thay đổi'}
          </button>
        </form>

        <div className="account-danger">
          <h3>Vùng nguy hiểm</h3>
          <p>Xoá tài khoản sẽ khoá quyền đăng nhập của bạn.</p>
          <button className="account-delete-btn" onClick={deleteAccount} disabled={deleting}>
            {deleting ? 'Đang xoá...' : 'Xoá tài khoản'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
